import { render, staticRenderFns } from "./ErrorBoundery.vue?vue&type=template&id=6018d988&scoped=true&"
import script from "./ErrorBoundery.vue?vue&type=script&lang=js&"
export * from "./ErrorBoundery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6018d988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
